import { FC, type ReactNode } from 'react';

interface BaseIconProps {
  color: string;
  pushRight?: boolean;
  children: ReactNode;
  title?: string;
}

const BaseIcon: FC<BaseIconProps> = ({ color, pushRight = true, children, title }) => {
  const accessibleTitle = title?.trim() || 'Allert Message';

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      stroke={color}
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
      style={{ marginRight: pushRight ? '20px' : '0', minWidth: 24 }}
      aria-label={accessibleTitle}
      role='img'
    >
      <title>{accessibleTitle}</title>
      {children}
    </svg>
  );
};

export default BaseIcon;
